import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Home from "./components/screens/Home";
import NotFound from "./components/screens/NotFound";
import Dossier from "./components/screens/Dossier";
import Citation from "./components/screens/Citation";


function App(props) {
  return (

      <Router >
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/dossier/:epaId"  component={Dossier} />
          <Route exact path="/citation/:category/:citationId" component={Citation} />
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
      </Router>
  );
}

export default App;
